import React from 'react';
import { IndexRedirect, Route } from 'react-router';
import { instantScrollTop } from 'swag-client-common/utils/tricks';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes.sendoso';
import { handleLoginFailed } from './route-hooks/route-hooks-other.sendoso';
import { onAccountMockups } from './route-hooks/route-hooks';
const LazySupervisorDashboard = /*#__PURE__*/React.lazy(() => {
  return import( /* webpackChunkName: "[SupervisorDashboard]" */'../components/routes/client/supervisor-dashboard');
});
const LazyAccountMockups = /*#__PURE__*/React.lazy(() => {
  return import( /* webpackChunkName: "[AccountMockups]" */'../components/routes/account/mockups');
});
export const OtherRoutes = ({
  store,
  dispatch
}) => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IndexRedirect, {
    to: APP_ROUTES.ALL_SWAG
  }), /*#__PURE__*/React.createElement(Route, {
    path: APP_ROUTES.SUPERVISOR_DASHBOARD_ORDER_APPROVAL,
    component: props => /*#__PURE__*/React.createElement(LazySupervisorDashboard, props),
    onEnter: instantScrollTop
  }), /*#__PURE__*/React.createElement(Route, {
    path: APP_ROUTES.SUPERVISOR_DASHBOARD_ALL_ORDERS,
    component: props => /*#__PURE__*/React.createElement(LazySupervisorDashboard, props),
    onEnter: instantScrollTop
  }), /*#__PURE__*/React.createElement(Route, {
    path: APP_ROUTES.SUPERVISOR_DASHBOARD_PAYMENT_SETTINGS,
    component: props => /*#__PURE__*/React.createElement(LazySupervisorDashboard, props),
    onEnter: instantScrollTop
  }), /*#__PURE__*/React.createElement(Route, {
    path: "login-failed/:code",
    onEnter: handleLoginFailed(store, dispatch)
  }), /*#__PURE__*/React.createElement(Route, {
    path: APP_ROUTES.ACCOUNT_SAVED_DESIGNS,
    component: props => /*#__PURE__*/React.createElement(LazyAccountMockups, props),
    onEnter: onAccountMockups(store, dispatch)
  }));
};